import React from 'react';
import Navbar from '../components/Navbar';
import CallCentersHero from '../components/callcenters/CallCentersHero';
import CallCentersProblem from '../components/callcenters/CallCentersProblem';
import WhyTraainCallCenters from '../components/callcenters/WhyTraainCallCenters';
import TrainingIntelligenceCallCenters from '../components/callcenters/TrainingIntelligenceCallCenters';
import RolePlayIntelligenceCallCenters from '../components/callcenters/RolePlayIntelligenceCallCenters';
import ExchangeCallCenters from '../components/callcenters/ExchangeCallCenters';
import CallCentersKPIs from '../components/callcenters/CallCentersKPIs';
import CallCentersCTA from '../components/callcenters/CallCentersCTA';
import Footer from '../components/Footer';

const CallCentersPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-blue-900 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-blue-600 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <CallCentersHero />
        <CallCentersProblem />
        <WhyTraainCallCenters />
        <TrainingIntelligenceCallCenters />
        <RolePlayIntelligenceCallCenters />
        <ExchangeCallCenters />
        <CallCentersKPIs />
        <CallCentersCTA />
        <Footer />
      </div>
    </div>
  );
};

export default CallCentersPage;
